import React, { Component } from "react";
import { connect } from "react-redux";
import Activecall from "./Activecall";
import Contact from "./Contact";
import { TippyPopper } from "../actions/Tippy";
import {
  ShowActiveCall,
  ShowInfoDisplay,
  ShowModalsMenu,
  GetCompanys,
  ClearContacts,
  GetInteractionsContact,
  getCompanys,
  GetHistory,
  GetNumbersContact,
  GetHistoryCalls,
  GetContacts,
  GetTypeNumbers,
  getTypeNumbers,
  AlterScreen,
  RemoveRemoteNotifier,
  menuToggle,
} from "../actions";

import { ReactComponent as DASHBOARD } from "../build/images/menu-side/graph.svg";
import { ReactComponent as CLIENTES } from "../build/images/menu-side/profile-2user.svg";
import { ReactComponent as ATENDENTES } from "../build/images/menu-side/personalcard.svg";
import { ReactComponent as EQUIPES } from "../build/images/menu-side/people.svg";
import { ReactComponent as HISTORICO } from "../build/images/menu-side/document-text.svg";
import { ReactComponent as MONITORIAS } from "../build/images/menu-side/presention-chart.svg";
import { ReactComponent as RELATORIOS } from "../build/images/menu-side/note.svg";
import { ReactComponent as CADASTROS } from "../build/images/menu-side/cadastros.svg";
import { ReactComponent as PORTALDEV } from "../build/images/menu-side/portaldev.svg";
import { ReactComponent as TAREFAS } from "../build/images/menu-side/task-square.svg";
import { ReactComponent as CASOS } from "../build/images/menu-side/document-text2.svg";
import { ReactComponent as MENUPRINCIP } from "../build/images/menu-side/menu.svg";
import { ReactComponent as ArrowDown } from "../build/images/arrow_down.svg";
import { ReactComponent as FACEBOOKICON } from "../build/images/Icon_Facebook-default.svg";
import { ReactComponent as INSTAGRAMICON } from "../build/images/Icon_Instagram-default.svg";
import { ReactComponent as NPSICON } from "../build/images/nps-dashboard-icons/starnps.svg";
import { ReactComponent as CAMPANHAS } from "../build/images/menu-side/volume-high.svg";
import { ReactComponent as CALLCENTER } from "../build/images/menu-side/call-center-icon.svg";
// import { ReactComponent as FACEBOOKICON } from "../build/images/Icon_Facebook-selected.svg";

import { FaStar } from "react-icons/fa";

import "../build/css/menu.css";

import TeamModal from "../modals/TeamModal";
import MicroModal from "micromodal";
const { connection_platform } = require("../services/api");

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  //ipcurrent = connection_platform.ip_apache_view_extern;

  ipcurrent =
    connection_platform.type_connect +
    "://" +
    connection_platform.ip_apache_view_extern +
    ":" +
    connection_platform.port_apache_view_extern;
  // if(parseInt(connection_platform.port_apache_view_extern) != 80){
  //     ipcurrent = ipcurrent+':'+connection_platform.port_apache_view_extern;
  // }
} else {
  //ipcurrent = connection_platform.ip_apache_view_intern;

  ipcurrent =
    connection_platform.type_connect +
    "://" +
    connection_platform.ip_apache_view_intern +
    ":" +
    connection_platform.port_apache_view_intern;
  // if(parseInt(connection_platform.port_apache_view_intern) != 80){
  //     ipcurrent = ipcurrent+':'+connection_platform.port_apache_view_intern;
  // }
}

const mapStateToProps = (state) => {
  return {
    VerificarID: state.opcoes,
    ShowActiveCall: state.showactivecall,
    InfoUsers: state.informationusers,
    InfoDisplay: state.infodisplay,
    IPCurrent: state.ipcurrent,
    ModalsVisor: state.modals,
    CurrentScreen: state.currentscreen,
    Chat: state.chatinternal,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ShowActiveCallIn: (post) => {
    dispatch(ShowActiveCall(post));
  },
  ShowInfoDisplay: (post) => {
    dispatch(ShowInfoDisplay(post));
    dispatch(AlterScreen(post));
    dispatch(GetHistoryCalls([]));
    dispatch(GetHistory([]));
    dispatch(getTypeNumbers([]));
    dispatch(GetInteractionsContact([]));
    dispatch(getCompanys([]));
    dispatch(GetNumbersContact([]));
  },
  AlterScreen: (post, previous) => {
    dispatch(AlterScreen(post, previous));
  },
  ShowModalsMenu: (post) => {
    dispatch(ShowModalsMenu(post));
  },
  RemoveRemoteNotifier: (post) => {
    dispatch(RemoveRemoteNotifier(post));
  },
  ShowCompanys: (post) => {
    dispatch(GetCompanys(post));
    dispatch(GetTypeNumbers(post));
  },
  ClearningContacts: (post) => {
    dispatch(ClearContacts([]));
    dispatch(getTypeNumbers([]));
  },
  expMenu: (post) => {
    dispatch(menuToggle(post));
  },
});

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = { buttonActiveIn: false, active: true, activeMore: false };
  }

  DisplayActiveIn(e) {
    this.props.ShowActiveCallIn("active");
  }

  ShowInfoDisplay(e, display, chat) {
    this.props.ShowInfoDisplay(display);
    this.VerifiedNotifier(display, chat);
  }

  VerifiedNotifier(display, chat) {
    if (display === "Atendentes") {
      this.props.RemoveRemoteNotifier(chat.iduserout);
    }
  }

  ButtonShowOptions(e) {
    e.preventDefault();
    this.setState({ showactionoptions: !this.state.showactionoptions });
    if (this.state.showactionoptions === true) {
      this.props.ClearningContacts();
    }
  }

  ShowModalsMenu(e, modal) {
    this.setState({ showactionoptions: !this.state.showactionoptions });
    this.props.ShowModalsMenu(modal);
    //this.props.ShowCompanys();
    if (modal === "modal__agenda") MicroModal.show("modal__agenda");
  }

  renderPopover = (e, name) => <span className="action-label">{name}</span>;

  ShowTeamModal(e, screen) {
    this.setState({ showactionoptions: !this.state.showactionoptions });
    MicroModal.show("modal__mensagem-equipe");
    this.props.AlterScreen("ChatGrupo", screen);
  }

  toggleClass(e) {
    e.preventDefault();
    this.setState({ active: !this.state.active });
    this.props.expMenu(this.state);
  }

  toggleMore(e) {
    e.preventDefault();
    this.setState({ activeMore: !this.state.activeMore });
  }

  render() {
    const {
      VerificarID,
      InfoUsers,
      IPCurrent,
      InfoDisplay,
      CurrentScreen,
      Chat,
    } = this.props;

    return (
      <div className={VerificarID.menu ? "menu-wrapper fixed" : "menu-wrapper"}>
        <div className="menu">
          <ul>
            <li>
              <a
                className="hamburger_menu toggle_menu"
                onClick={this.toggleClass.bind(this)}
              >
                <div className="icon">
                  <MENUPRINCIP />
                </div>
              </a>
            </li>
            {(() => {
              if (
                InfoUsers.supervisor === true &&
                connection_platform.manager_screen_old
              ) {
                return (
                  <li>
                    <a
                      className={
                        InfoDisplay.infodisplay === "Gestor" ? "active" : ""
                      }
                      onClick={(event) => this.ShowInfoDisplay(event, "Gestor")}
                    >
                      <div className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                        >
                          <g id="Layer_2" data-name="Layer 2">
                            <g id="Layer_1-2" data-name="Layer 1">
                              <g id="Layer_1-2-2" data-name="Layer 1-2">
                                <path
                                  className="cls-2"
                                  d="M19.49,6.71a.83.83,0,0,0-1.07-.1c-1.25.85-7.52,5.14-8.19,5.81A2.51,2.51,0,0,0,13.77,16c.68-.68,5-7,5.82-8.2A.85.85,0,0,0,19.49,6.71Zm-6.9,8.07a.83.83,0,0,1-1.18-1.18c.26-.26,2-1.53,4.23-3C14.12,12.74,12.85,14.52,12.59,14.78Z"
                                />
                                <path
                                  className="cls-2"
                                  d="M5.16,18.08l-1,.5A9,9,0,0,1,3.56,11l1.18.57a.94.94,0,0,0,.36.08.85.85,0,0,0,.76-.48.84.84,0,0,0-.39-1.11L4.3,9.49a9,9,0,0,1,6.86-4.28V6.46a.84.84,0,1,0,1.68,0V5.21A9,9,0,0,1,15.71,6a.84.84,0,0,0,1.11-.42.83.83,0,0,0-.42-1.1,10.72,10.72,0,0,0-12,2.19,10.66,10.66,0,0,0-1.33,13.5.84.84,0,0,0,.7.37.83.83,0,0,0,.37-.08l1.71-.84a.83.83,0,0,0-.73-1.5Z"
                                />
                                <path
                                  className="cls-2"
                                  d="M21.76,9.8a.84.84,0,0,0-1.11-.42.83.83,0,0,0-.42,1.1,9,9,0,0,1-.36,8.11l-1.08-.51a.83.83,0,1,0-.71,1.51l1.75.83a.78.78,0,0,0,.36.08.84.84,0,0,0,.7-.37A10.68,10.68,0,0,0,21.76,9.8Z"
                                />
                              </g>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div className="label">Dashboard</div>
                    </a>
                  </li>
                );
              }
            })()}
            {(() => {
              if (
                InfoUsers.supervisor === true &&
                connection_platform.manager_screen_new
              ) {
                return (
                  <li>
                    <a
                      className={
                        InfoDisplay.infodisplay === "Gestor2" ? "active" : ""
                      }
                      onClick={(event) =>
                        this.ShowInfoDisplay(event, "Gestor2")
                      }
                    >
                      <div className="icon">
                        <DASHBOARD />
                      </div>
                      <div className="label">Dashboard</div>
                    </a>
                  </li>
                );
              }
            })()}
            <li>
              <a
                className={
                  InfoDisplay.infodisplay === "Clientes" ? "active" : ""
                }
                onClick={(event) => this.ShowInfoDisplay(event, "Clientes")}
              >
                <div className="icon">
                  <CLIENTES />
                </div>
                <div className="label">Clientes</div>
              </a>
            </li>
            <li>
              <a
                className={
                  InfoDisplay.infodisplay === "Atendentes" ? "active" : ""
                }
                onClick={(event) =>
                  this.ShowInfoDisplay(event, "Atendentes", Chat)
                }
              >
                <div className="icon">
                  <ATENDENTES />
                </div>
                <div className="label">Atendentes</div>
              </a>
            </li>

            <li>
              <a
                className={
                  InfoDisplay.infodisplay === "Equipes" ? "active" : ""
                }
                onClick={(event) => this.ShowInfoDisplay(event, "Equipes")}
              >
                <div className="icon">
                  <EQUIPES />
                </div>
                <div className="label">Equipes</div>
              </a>
            </li>
            <li>
              <a
                className={
                  InfoDisplay.infodisplay === "Historic" ? "active" : ""
                }
                onClick={(event) => this.ShowInfoDisplay(event, "Historic")}
              >
                <div className="icon">
                  <HISTORICO />
                </div>
                <div className="label">Histórico</div>
              </a>
            </li>
            {/* NPS */}
            {(() => {
              if (InfoUsers.qualidade === true) {
                return (
                  <li>
                    <a
                      className={
                        InfoDisplay.infodisplay === "NPS"
                          ? "active  nps-icon"
                          : ""
                      }
                      onClick={(event) => this.ShowInfoDisplay(event, "NPS")}
                    >
                      <div className="icon">
                        <NPSICON />
                      </div>
                      <div className="label">Qualidade</div>
                    </a>
                  </li>
                );
              }
            })()}
            {/* call center */}

            {(() => {
              if (
                InfoUsers.gerente === true &&
                connection_platform.visibleCallCenter === true
              ) {
                return (
                  <li>
                    <a
                      className={
                        InfoDisplay.infodisplay === "QualityAgent"
                          ? "active"
                          : ""
                      }
                      onClick={(event) =>
                        this.ShowInfoDisplay(event, "QualityAgent")
                      }
                    >
                      <div className="icon call-center">
                        <CALLCENTER />
                      </div>
                      <div className="label">Call Center</div>
                    </a>
                  </li>
                );
              }
            })()}

            {(() => {
              if (connection_platform.buttonface === true) {
                return (
                  <TippyPopper
                    content={this.renderPopover(
                      this,
                      "Acessar uma conta da Meta"
                    )}
                  >
                    <li>
                      <a
                        className={
                          InfoDisplay.infodisplay === "Facebook"
                            ? "active  nps-icon"
                            : ""
                        }
                        onClick={() =>
                          window.open(
                            "https://www.facebook.com/v18.0/dialog/oauth?app_id=6998422056945909&cbt=1707136787144&channel_url=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df7006076f88e87a2e%26domain%3Dcloud.ingweb.com.br%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fcloud.ingweb.com.br%253A3006%252Ff548a851e83ce79b4%26relation%3Dopener&client_id=6998422056945909&config_id=354636957178727&display=popup&domain=cloud.ingweb.com.br&e2e=%7B%7D&fallback_redirect_uri=https%3A%2F%2Fcloud.ingweb.com.br%3A3006%2Ftechprovider.html&locale=en_US&logger_id=fa4d3054a073c02fe&origin=1&override_default_response_type=true&redirect_uri=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df846fa9903170e641%26domain%3Dcloud.ingweb.com.br%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fcloud.ingweb.com.br%253A3006%252Ff548a851e83ce79b4%26relation%3Dopener%26frame%3Df3d16cc0f22e8295d&response_type=code&sdk=joey&version=v18.0",
                            "about",
                            "height=750,width=650"
                          )
                        }
                      >
                        <div className="icon">
                          <FACEBOOKICON />
                        </div>
                        <div className="label">Facebook</div>
                      </a>
                    </li>
                  </TippyPopper>
                );
              }
            })()}

            {(() => {
              if (connection_platform.buttoninstagram === true) {
                return (
                  <TippyPopper
                    content={this.renderPopover(
                      this,
                      "Acessar uma conta do Instagram"
                    )}
                  >
                    <li>
                      <a
                        className={
                          InfoDisplay.infodisplay === "Instagram"
                            ? "active  nps-icon"
                            : ""
                        }
                        onClick={() =>
                          window.open(
                            "https://www.facebook.com/v18.0/dialog/oauth?app_id=762256599016287&cbt=1707136787144&channel_url=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df7006076f88e87a2e%26domain%3Dcloud.ingweb.com.br%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fcloud.ingweb.com.br%253A3006%252Ff548a851e83ce79b4%26relation%3Dopener&client_id=6998422056945909&config_id=238253192682660&display=popup&domain=cloud.ingweb.com.br&e2e=%7B%7D&fallback_redirect_uri=https%3A%2F%2Fcloud.ingweb.com.br%3A3006%2Ftechprovider.html&locale=en_US&logger_id=fa4d3054a073c02fe&origin=1&override_default_response_type=true&redirect_uri=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df846fa9903170e641%26domain%3Dcloud.ingweb.com.br%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fcloud.ingweb.com.br%253A3006%252Ff548a851e83ce79b4%26relation%3Dopener%26frame%3Df3d16cc0f22e8295d&response_type=code&sdk=joey&version=v18.0",
                            "about",
                            "height=750,width=650"
                          )
                        }
                      >
                        <div className="icon">
                          <INSTAGRAMICON />
                        </div>
                        <div className="label">Instagram</div>
                      </a>
                    </li>
                  </TippyPopper>
                );
              }
            })()}

            {(() => {
              if (
                InfoUsers.supervisor === true &&
                connection_platform.seeCampaigns
              ) {
                return (
                  <li>
                    <a
                      className={
                        InfoDisplay.infodisplay === "Campanhas" ? "active" : ""
                      }
                      onClick={(event) =>
                        this.ShowInfoDisplay(event, "Campanhas")
                      }
                    >
                      <div className="icon">
                        <CAMPANHAS className="fill-color" />
                      </div>
                      <div className="label">Campanhas</div>
                    </a>
                  </li>
                );
              }
            })()}

            {(() => {
              if (InfoUsers.supervisor === true) {
                return (
                  <li>
                    <a
                      className={
                        InfoDisplay.infodisplay === "Monitorias" ? "active" : ""
                      }
                      onClick={(event) =>
                        this.ShowInfoDisplay(event, "Monitorias")
                      }
                    >
                      <div className="icon">
                        <MONITORIAS />
                      </div>
                      <div className="label">Monitorias</div>
                    </a>
                  </li>
                );
              }
            })()}

            <li>
              <a className="more" onClick={this.toggleMore.bind(this)}>
                <div className="icon">
                  <ArrowDown
                    className={this.state.activeMore ? "active-icon" : ""}
                  />
                </div>
                <div className="label">
                  {this.state.activeMore ? "Menos" : "Mais"}
                </div>
              </a>
            </li>

            {/* <li> */}
            {/* <a onClick={event => this.ShowInfoDisplay(event, 'Arquivos')} className={InfoDisplay.infodisplay === 'Arquivos' ? 'active': ""}> */}
            {/* <a className={InfoDisplay.infodisplay === 'Arquivos' ? 'active': ""}>
                <div className="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 23.332"><g transform="translate(10.787 16.162)"><path className="icon_menu_arquivos_fill" d="M191.626,332.734h-6.617a.905.905,0,0,0-.9.9v2.029a.905.905,0,0,0,.9.9h6.617a.905.905,0,0,0,.9-.9v-2.029A.906.906,0,0,0,191.626,332.734Zm-.258,2.675h-6.1V333.9h6.1Z" transform="translate(-184.105 -332.734)"></path></g><g transform="translate(0 0)"><path className="icon_menu_arquivos_fill" d="M29.706,68.038l.009,0-4.36-8.619a2.048,2.048,0,0,0-1.837-1.129H22.69v-.8a.581.581,0,0,0-.581-.581H7.891a.581.581,0,0,0-.581.581v.8H6.481a2.048,2.048,0,0,0-1.837,1.129L.285,68.033l.009,0A2.024,2.024,0,0,0,0,69.092V78.2a2.039,2.039,0,0,0,2.036,2.036H27.964A2.039,2.039,0,0,0,30,78.2V69.092A2.024,2.024,0,0,0,29.706,68.038ZM22.69,59.577h.829A.763.763,0,0,1,24.2,60l3.57,7.058H25.345V64.884a.581.581,0,0,0-.581-.581h-.719V61.184a.581.581,0,0,0-.581-.581H22.69Zm1.492,5.888v1.59H21.114a1.343,1.343,0,0,0-1.223.79L19.054,69.7a.049.049,0,0,1-.045.029H10.991a.049.049,0,0,1-.045-.029l-.838-1.858a1.343,1.343,0,0,0-1.223-.79H5.818v-1.59Zm-15.709-7.4H21.527V60.6H8.473Zm14.409,3.7V64.3H7.118V61.765ZM5.8,60a.763.763,0,0,1,.684-.421H7.31V60.6H6.537a.581.581,0,0,0-.581.581V64.3H5.236a.581.581,0,0,0-.581.581v2.172H2.227ZM27.964,78.942H2.036a.745.745,0,0,1-.744-.744V69.092a.745.745,0,0,1,.744-.744H8.886a.049.049,0,0,1,.045.029l.838,1.858a1.343,1.343,0,0,0,1.223.79h8.019a1.343,1.343,0,0,0,1.223-.79l.838-1.858h0a.049.049,0,0,1,.045-.029h6.849a.745.745,0,0,1,.744.744V78.2h0A.745.745,0,0,1,27.964,78.942Z" transform="translate(0 -56.902)"></path></g></svg>
                </div>
                <div className="label">Arquivos</div>
              </a>
            </li> */}
            <ul
              className={`more-list ${this.state.activeMore ? "active" : ""}`}
            >
              {(() => {
                if (InfoUsers.nameauth === "IngDesk") {
                  return (
                    <li>
                      <a
                        onClick={(event) =>
                          this.ShowInfoDisplay(event, "IngDesk")
                        }
                        className={
                          InfoDisplay.infodisplay === "IngDesk" ? "active" : ""
                        }
                      >
                        <div className="icon">
                          <TAREFAS />
                        </div>
                        <div className="label">Tarefas</div>
                      </a>
                    </li>
                  );
                }
              })()}
              {(() => {
                if (InfoUsers.nameauth === "IngDesk") {
                  return (
                    <li>
                      <a
                        onClick={(event) =>
                          this.ShowInfoDisplay(event, "Casos")
                        }
                        className={
                          InfoDisplay.infodisplay === "Casos" ? "active" : ""
                        }
                      >
                        <div className="icon">
                          <CASOS />
                        </div>
                        <div className="label">Casos</div>
                      </a>
                    </li>
                  );
                }
              })()}

              {(() => {
                if (InfoUsers.gerente === true) {
                  return (
                    <li>
                      <a
                        className={
                          InfoDisplay.infodisplay === "Relatorios"
                            ? "active"
                            : ""
                        }
                        href={
                          InfoUsers.relatorio + "/ingweb.php?id=" + InfoUsers.id
                        }
                        target="_blank"
                      >
                        <div className="icon">
                          <RELATORIOS />
                        </div>
                        <div className="label">Relatórios</div>
                      </a>
                    </li>
                  );
                }
              })()}

              {(() => {
                if (InfoUsers.suporte === true) {
                  return (
                    <li>
                      <a
                        className={
                          InfoDisplay.infodisplay === "Cadastros"
                            ? "active"
                            : ""
                        }
                        href={
                          InfoUsers.cadastros +
                          "/ingweb.php?id=" +
                          InfoUsers.id +
                          "&name=" +
                          InfoUsers.displayname
                        }
                        target="_blank"
                      >
                        <div className="icon">
                          <CADASTROS />
                        </div>
                        <div className="label">Cadastros</div>
                      </a>
                    </li>
                  );
                }
              })()}

              {(() => {
                if (InfoUsers.gerente === true && InfoUsers.suporte === true) {
                  return (
                    <li>
                      <a
                        className={
                          InfoDisplay.infodisplay === "Portal" ? "active" : ""
                        }
                        href={
                          InfoUsers.portal +
                          "/ingweb.php?id=" +
                          InfoUsers.id +
                          "&name=" +
                          InfoUsers.displayname
                        }
                        target="_blank"
                      >
                        <div className="icon">
                          <PORTALDEV />
                        </div>
                        <div className="label">Portal</div>
                      </a>
                    </li>
                  );
                }
              })()}
              {(() => {
                if (connection_platform.isExistMail === true) {
                  return (
                    <li>
                      <a
                        onClick={(event) =>
                          this.ShowInfoDisplay(event, "Email")
                        }
                        className={
                          InfoDisplay.infodisplay === "Email" ? "active" : ""
                        }
                      >
                        <div className="icon">
                          <svg
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.5 21.25H7.5C3.85 21.25 1.75 19.15 1.75 15.5V8.5C1.75 4.85 3.85 2.75 7.5 2.75H17.5C21.15 2.75 23.25 4.85 23.25 8.5V15.5C23.25 19.15 21.15 21.25 17.5 21.25ZM7.5 4.25C4.64 4.25 3.25 5.64 3.25 8.5V15.5C3.25 18.36 4.64 19.75 7.5 19.75H17.5C20.36 19.75 21.75 18.36 21.75 15.5V8.5C21.75 5.64 20.36 4.25 17.5 4.25H7.5Z"
                              fill="#455CC7"
                            />
                            <path
                              d="M12.4998 12.87C11.6598 12.87 10.8098 12.61 10.1598 12.08L7.02978 9.57997C6.70978 9.31997 6.64978 8.84997 6.90978 8.52997C7.16978 8.20997 7.63978 8.14997 7.95978 8.40997L11.0898 10.91C11.8498 11.52 13.1398 11.52 13.8998 10.91L17.0298 8.40997C17.3498 8.14997 17.8298 8.19997 18.0798 8.52997C18.3398 8.84997 18.2898 9.32997 17.9598 9.57997L14.8298 12.08C14.1898 12.61 13.3398 12.87 12.4998 12.87Z"
                              fill="#455CC7"
                            />
                          </svg>
                        </div>
                        <div className="label">Email</div>
                      </a>
                    </li>
                  );
                }
              })()}
            </ul>
          </ul>
          <div
            className={
              this.state.showactionoptions
                ? "app-overlay active"
                : "app-overlay"
            }
          ></div>
          <div
            className={
              this.state.showactionoptions
                ? "side-menu__add-section active"
                : "side-menu__add-section"
            }
          >
            <div className="action one">
              <TippyPopper
                content={this.renderPopover(this, "Mensagem para Equipe")}
              >
                <button
                  onClick={(event) =>
                    this.ShowTeamModal(event, CurrentScreen.screen)
                  }
                  className="action-btn tippy-default"
                  data-tippy-content="Mensagem para equipe"
                  data-tippy-theme="light"
                  data-tippy-placement="right"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#B7BEC5"
                      d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
                    />
                  </svg>
                </button>
              </TippyPopper>
            </div>
            <div className="action one">
              <TippyPopper content={this.renderPopover(this, "Contatos")}>
                <button
                  className="action-btn"
                  data-tippy-content="Contatos"
                  data-tippy-theme="light"
                  data-tippy-placement="right"
                  onClick={(event) =>
                    this.ShowModalsMenu(event, "modal__agenda")
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                  >
                    <text
                      transform="translate(9 18)"
                      fill="#fff"
                      fontSize="18"
                      fontFamily="MaterialIcons-Regular, Material Icons"
                    >
                      <tspan x="-9" y="0">
                        contacts
                      </tspan>
                    </text>
                  </svg>
                </button>
              </TippyPopper>
              {/* <span className="action-label">Contatos</span> */}
            </div>
            {/* <div className="action two">
              <TippyPopper content={this.renderPopover(this, 'Calendário')}><button className="action-btn"><svg xmlns="http://www.w3.org/2000/svg" data-tippy-content="Calendário" data-tippy-theme="light" data-tippy-placement="right" width="18" height="18" viewBox="0 0 18 18"><text transform="translate(9 18)" fill="#fff" fontSize="18" fontFamily="MaterialIcons-Regular, Material Icons"><tspan x="-9" y="0">perm_contact_calendar</tspan></text></svg></button></TippyPopper> */}
            {/* <span className="action-label">Calendário</span> */}
            {/* </div> */}
          </div>
          <div
            className={
              this.state.showactionoptions
                ? "side-menu__btn second  side-menu__add-btn active"
                : "side-menu__btn second  side-menu__add-btn"
            }
            onClick={(event) => this.ButtonShowOptions(event)}
          >
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><text transform="translate(10 20)" fill="#005daa" fontSize="20" fontFamily="MaterialIcons-Regular, Material Icons"><tspan x="-10" y="0">add</tspan></text></svg> */}
            <div>
              <svg
                width="56"
                height="56"
                viewBox="0 0 56 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {/* <g filter="url(#filter0_d_1_1832)">
              <circle cx="8" cy="7" r="24" fill="white"/>
              </g> */}
                <path
                  d="M33.75 31.75V32.25H34.25H36.5C36.6339 32.25 36.75 32.3661 36.75 32.5C36.75 32.6339 36.6339 32.75 36.5 32.75H34.25H33.75V33.25V35.5C33.75 35.6339 33.6339 35.75 33.5 35.75C33.3661 35.75 33.25 35.6339 33.25 35.5V33.25V32.75H32.75H30.5C30.3661 32.75 30.25 32.6339 30.25 32.5C30.25 32.3661 30.3661 32.25 30.5 32.25H32.75H33.25V31.75V29.5C33.25 29.3661 33.3661 29.25 33.5 29.25C33.6339 29.25 33.75 29.3661 33.75 29.5V31.75Z"
                  fill="#292D32"
                  stroke="#455CC7"
                />
                <path
                  d="M38 23.52V18.98C38 17.57 37.36 17 35.77 17H31.73C30.14 17 29.5 17.57 29.5 18.98V23.51C29.5 24.93 30.14 25.49 31.73 25.49H35.77C37.36 25.5 38 24.93 38 23.52Z"
                  fill="#3C51B1"
                />
                <path
                  d="M26.5 23.52V18.98C26.5 17.57 25.86 17 24.27 17H20.23C18.64 17 18 17.57 18 18.98V23.51C18 24.93 18.64 25.49 20.23 25.49H24.27C25.86 25.5 26.5 24.93 26.5 23.52Z"
                  fill="#3C51B1"
                />
                <path
                  d="M26.5 34.77V30.73C26.5 29.14 25.86 28.5 24.27 28.5H20.23C18.64 28.5 18 29.14 18 30.73V34.77C18 36.36 18.64 37 20.23 37H24.27C25.86 37 26.5 36.36 26.5 34.77Z"
                  fill="#3C51B1"
                />
                {/* <defs>
              <filter id="filter0_d_1_1832" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dy="1"/>
              <feGaussianBlur stdDeviation="2"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_1832"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_1832" result="shape"/>
              </filter>
              </defs> */}
              </svg>
            </div>
          </div>
          <button
            className="side-menu__btn first side-menu__fcc-btn"
            onClick={(event) => this.DisplayActiveIn(event)}
            data-micromodal-trigger="modal__falar-com-cliente"
          >
            <span className="side-menu__tooltip">Falar com cliente</span>

            <i className="material-icons">call</i>
          </button>
        </div>
        <Activecall />
        <Contact />
        <div
          className="modal micromodal-slide"
          id="modal__mensagem-equipe"
          style={{ zIndex: "9999999999999999999999999" }}
          aria-hidden="true"
          role="dialog"
        >
          <TeamModal />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
